<div class="card">
    <div class="card-header">
        Company Document
    </div>
    <div class="card-body">
        <iframe  [src]="safeUrl" width="100%" height="100%" frameBorder="0"></iframe>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">

                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>